import { combineReducers } from "redux";
import authSlice from "./auth";

const rootReducers = combineReducers({
    auth: authSlice,
});

export default rootReducers;
